import { useBookingContext } from "modules/Booking/BookingContext"
import { Analytics } from "utils/analytics"
import { SESSION_TYPE } from "modules/Booking/common/constants"
import { BottomFixed } from "components/Footer"
import { Button } from "ui-kit/components-branded/index"
import { useOnlyFreeSessions } from "pages/FreePsysPage/useOnlyFreeSessions"
import { SessionInfoShort } from "modules/Booking/FormPage/common/SessionInfoShort"

export function NextPageButtonWithAdditionalInfo(props: { regimen: string }) {
    const onlyFree = useOnlyFreeSessions()
    const [, { nextPage, changeSessionType }] = useBookingContext()

    const next = () => {
        if (onlyFree) {
            Analytics.session_time_selected_free()
        } else {
            Analytics.session_time_selected()
        }
        changeSessionType(SESSION_TYPE.DEFAULT)
        nextPage()
    }

    return props.regimen === "desktop" ? (
        <Button color="primary" isFullwidth onClick={next}>
            Дальше
        </Button>
    ) : (
        <BottomFixed className="booking__fixed-next-button">
            <SessionInfoShort />
            <Button onClick={next} color="primary" isFullwidth>
                Дальше
            </Button>
        </BottomFixed>
    )
}
